export default function PageHero({ eyebrow, title, accent, description }) {
  return (
    <section className="relative pt-36 pb-16 lg:pt-44 lg:pb-24 overflow-hidden border-b border-white/5" data-testid="page-hero">
      {/* Halos */}
      <div className="absolute -top-10 right-0 w-[620px] h-[440px] bg-[#E50914]/14 blur-[150px] rounded-full pointer-events-none animate-glow"></div>
      <div className="absolute bottom-0 left-0 w-[420px] h-[300px] bg-[#E50914]/8 blur-[140px] rounded-full pointer-events-none"></div>

      {/* Grille fine */}
      <div className="absolute inset-0 opacity-[0.10] pointer-events-none"
        style={{
          backgroundImage: `linear-gradient(rgba(229,9,20,0.10) 1px, transparent 1px), linear-gradient(90deg, rgba(229,9,20,0.10) 1px, transparent 1px)`,
          backgroundSize: "64px 64px",
          maskImage: "radial-gradient(ellipse at top right, black, transparent 75%)",
          WebkitMaskImage: "radial-gradient(ellipse at top right, black, transparent 75%)",
        }}
      ></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="inline-flex items-center gap-2.5 px-4 py-2 mb-7 rounded-full bg-white/[0.04] border border-[#E50914]/40 backdrop-blur-sm animate-fade-up">
          <span className="w-2 h-2 rounded-full bg-[#E50914] pulse-red"></span>
          <span className="text-[11px] uppercase tracking-[0.28em] font-bold text-white/90">{eyebrow?.replace(/^\/\s*/, "")}</span>
        </div>

        <div className="flex items-start gap-5 animate-fade-up" style={{ animationDelay: "0.1s" }}>
          <span className="hidden sm:block mt-3 w-1.5 self-stretch rounded-full bg-gradient-to-b from-[#E50914] to-transparent"></span>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl xl:text-[5.5rem] font-black tracking-tighter leading-[0.92]">
            <span className="block text-white">{title}</span>
            <span className="block text-gradient-red">{accent}</span>
          </h1>
        </div>

        {description && (
          <div className="mt-7 max-w-2xl animate-fade-up" style={{ animationDelay: "0.2s" }}>
            <div className="hairline mb-5 max-w-xs"></div>
            <p className="text-lg text-white/65 leading-relaxed">{description}</p>
          </div>
        )}
      </div>
    </section>
  );
}
